@if ((results$ | async); as results)
{
    <div>
        <div class="search-container">
            <mvp-search [currentSearch]="currentSearch"
                        [showControls]="true"
                        (filtersToggled)="showFilters = !showFilters"></mvp-search>
        </div>
        <mat-paginator [length]="results.totalItems"
                       [pageSize]="results.pageSize"
                       [pageIndex]="results.page - 1"
                       (page)="paged($event)"
                       showFirstLastButtons="true"
                       hidePageSize="true">
        </mat-paginator>
        <div class="filter-container" [class.closed]="!showFilters" [class.open]="showFilters">
            <div class="filters">
                <div class="button"
                     [class.active]="filtersSelected"
                     (click)="runSearch()">apply</div>
            </div>
            <div class="filters">
                <span>years</span>
                @for (year of years; track year)
                {
                    <div [class.active]="year.selected"
                         (click)="toggleFilter(year)">{{getFacetDescription(year)}}</div>
                }
            </div>
            <hr />
            <div class="filters">
                <span>months</span>
                @for (month of months; track month)
                {
                    <div [class.active]="month.selected"
                         (click)="toggleFilter(month)">{{getFacetDescription(month)}}</div>
                }
            </div>
            <hr />
            <div class="filters">
                <span>tags</span>
                @for (tag of tags; track tag)
                {
                    <div [class.active]="tag.selected"
                         (click)="toggleFilter(tag)">{{getFacetDescription(tag)}}</div>
                }
            </div>
        </div>
        <mvp-layout [thumbnails$]="resultPreviews$"
                    (selected)="resultSelected($event)"></mvp-layout>
        @if (results == null || results.totalItems === 0)
        {
            <div class="no-results">no results!</div>
        }
    </div>
} @else
{
  <div class="loading">
    <img class="fixed-centre-postnav" src="../../../assets/aperture.gif" />
    <p>loading search...</p>
  </div>
}

